import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { SignUp } from '../components/SignUp/SignUp';
import { PropsWithChildren } from 'react';
import { paths } from '../routes/paths';
import { useFlags } from 'launchdarkly-react-client-sdk';

export const SignUpPage = () => {
  const reCaptchaKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';
  const { enableReCaptchaInSignUp } = useFlags();

  const GoogleReCaptchaProviderWrapper = ({ children }: PropsWithChildren) => {
    if (enableReCaptchaInSignUp) {
      return (
        <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey}>
          {children}
        </GoogleReCaptchaProvider>
      );
    }
    return <>{children}</>;
  };

  return (
    <GoogleReCaptchaProviderWrapper>
      <SignUp />
    </GoogleReCaptchaProviderWrapper>
  );
};

SignUpPage.path = paths.signup;
